import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["xlink:href"];
import { isExternal } from '@/utils/validate';

import { toRefs, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
    iconClass: {},
    className: {}
  },
  setup(__props) {
    const prop = __props;
    const {
      iconClass,
      className
    } = toRefs(prop);
    const external = computed(() => isExternal(iconClass.value));
    const isElement = computed(() => iconClass.value.startsWith('el'));
    const iconName = computed(() => `#icon-${iconClass.value}`);
    const svgClass = computed(() => {
      if (className?.value) {
        return 'svg-icon ' + className.value;
      } else {
        return 'svg-icon';
      }
    });
    const styleExternalIcon = computed(() => {
      return {
        mask: `url(${iconClass.value}) no-repeat 50% 50%`,
        '-webkit-mask': `url(${iconClass.value}) no-repeat 50% 50%`
      };
    });
    return (_ctx, _cache) => {
      return _unref(external) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(_unref(styleExternalIcon)),
        class: "svg-external-icon svg-icon"
      }, null, 4)) : _unref(isElement) ? (_openBlock(), _createElementBlock("i", {
        key: 1,
        class: _normalizeClass(_unref(iconClass))
      }, null, 2)) : (_openBlock(), _createElementBlock("svg", {
        key: 2,
        class: _normalizeClass(_unref(svgClass)),
        "aria-hidden": "true"
      }, [_createElementVNode("use", {
        "xlink:href": _unref(iconName)
      }, null, 8, _hoisted_1)], 2));
    };
  }
});